module.exports = __webpack_public_path__ + "static/media/riya_kulkarni.f1a9f8e8.png";